module.exports = __webpack_public_path__ + "img/new-window.3d8fd729.svg";